module.exports = __webpack_public_path__ + "static/media/oil&gas.52bd3f5c.png";